export default __webpack_public_path__ + "static/bg-elevating-1c0e90d1275dad150003980d3879abe7.png";